/**
 * The free trial on paid plans (migrations 20261004100000_free_trial and
 * 20261013100000_trial_3_days).
 *
 * Every paid plan with trial_days (3) starts with a free trial for an account
 * that has never paid and never trialled. A card is taken at checkout and
 * charged when the trial ends, unless the trial is cancelled first. During the
 * trial the account has the plan's trial credits (plan_tiers.trial_credits):
 * 500 on Pro and Growth, 25% of the entry credit level on Starter and Standard.
 * The full credits and the welcome credits come with the first payment.
 * create-checkout decides for real; this mirrors it for the page.
 */

/** Trial length the site talks about. The plans carry their own (plan_tiers.trial_days). */
export const TRIAL_DAYS = 3;

/** Fallback share of the entry credit level when a plan row has no trial_credits. */
export const TRIAL_CREDIT_SHARE = 0.25;

export interface TrialOffer {
  days: number;
  credits: number;
}

/** The trial a plan offers, or null. Credits: the plan's trial_credits, else 25% of its smallest credit level. */
export function trialOfferFor(
  plan: { trial_days?: number | null; trial_credits?: number | null; credits_per_month?: number | null },
  levels: Array<{ credits: number }> = [],
): TrialOffer | null {
  const days = Number(plan.trial_days) || 0;
  if (days <= 0) return null;
  const set = Number(plan.trial_credits) || 0;
  if (set > 0) return { days, credits: set };
  const entry = levels.length ? Math.min(...levels.map((l) => l.credits)) : Number(plan.credits_per_month) || 0;
  return { days, credits: Math.ceil(entry * TRIAL_CREDIT_SHARE) };
}

/** "3-day free trial" */
export const trialLabel = (t: TrialOffer) => `${t.days}-day free trial`;
